import { ChromePicker } from 'react-color'
import React, { useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from '../../../../UserSettings.module.scss'
import textStyles from '../TextSettings/TextSettings.module.scss'
import { setEditingAlias, setPickerPosition, togglePicker } from '../../../../../Redux/slices/aliases'
import { BlockIcon } from '../../../../../helpers/icons'
import { Button } from 'antd'
import { LockOutlined, UnlockOutlined } from '@ant-design/icons'
import { useActions } from '../../../../../hooks/useActions'

export function PickerArea({ setVisible, onColorPicked, color, position }) {
	const dispatch = useDispatch()

	return (
		<div className={[styles.popover, position ? styles[`popover${position}`] : styles.popoverBottom].join(' ')}>
			<div
				className={styles.cover}
				onClick={(e) => {
					setVisible(false)
					dispatch(setEditingAlias(false))
					e.stopPropagation()
				}}
			/>
			<ChromePicker color={color} onChange={(color) => onColorPicked(color.hex)} disableAlpha />
		</div>
	)
}

export default function ColorPicker({
	pickerLabel = '',
	onColorPicked,
	color,
	paintLabel = false,
	withMargin = true,
	onMouseLeave,
	onMouseEnter,
	isAliasPicker,
	aliasIndex,
	position,
	isDisable,
}) {
	const [isVisible, setVisible] = useState(false)
	const dispatch = useDispatch()
	const { setIsShowAdvancedSettings } = useActions()

	// helper utils for aliases object
	const { editingAliasIndex, isCreatingNewAlias, activeAliasIndex } = useSelector((state) => state.aliases)
	const isActiveAlias = aliasIndex === editingAliasIndex
	const isActiveCreatingAlias = aliasIndex === activeAliasIndex

	const ref = useRef(null)

	// count offsets for element
	useEffect(() => {
		const currentElement = ref.current
		if (aliasIndex === activeAliasIndex && isAliasPicker) {
			// activeAliasIndex instead of editingAliasIndex
			dispatch(setPickerPosition(currentElement.getBoundingClientRect().x, currentElement.getBoundingClientRect().y))
		}
	}, [isVisible, dispatch])

	return (
		<div
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			className={styles.colorPickerContainer}
			style={{ marginBottom: withMargin && 10 }}
		>
			<div className={styles.actionContainer}>
				<div
					className={styles.swatch}
					onClick={(e) => {
						e.stopPropagation()

						setVisible((prevState) => !prevState)
						if (isActiveAlias || (isActiveCreatingAlias && isCreatingNewAlias)) dispatch(togglePicker())
					}}
					ref={ref}
				>
					<div className={styles.color} style={{ backgroundColor: color }} />
				</div>

				{isVisible && !isAliasPicker && (
					<PickerArea
						color={color}
						onColorPicked={(color) => onColorPicked(color)}
						setVisible={() => setVisible(false)}
						position={position}
					/>
				)}

				<span style={{ color: paintLabel && color }}>{pickerLabel}</span>
			</div>
		</div>
	)
}
